import { createAction, handleActions } from 'redux-actions';
import update from 'immutability-helper';

import UserService from 'scripts/services/UserService';

const ADVISOR_DETAILS = 'scripts/account/ADVISOR_DETAILS';

export const advisorDetails = createAction(ADVISOR_DETAILS);


export function fetchAdvisorDetails() {
    return async function (dispatch, getState) {
        const { user } = getState();
        if (user.loggedIn) {
        const payload = await UserService.getAdvisorDetails(user.id);
        return dispatch(advisorDetails(payload));
        }
    };
}

const reducer = handleActions({
  [ADVISOR_DETAILS]: (state, action) => update(state, {
    $set: action.payload
  }),
}, null);

export default reducer;
